import { NgClass } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { CheckoutWrapperComponent as CheckoutWrapperComponentLib } from '@pixelgenau/ngx-checkouts';

@Component({
    selector: 'ui-m000-c030-checkout-wrapper[identifier]',
    standalone: true,
    imports: [NgClass],
    templateUrl: './m000-c030-checkout-wrapper.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M000C030CheckoutWrapperComponent extends CheckoutWrapperComponentLib {
    onlyOneStep = input(false, { transform: booleanAttribute });
}
